module.exports = __webpack_public_path__ + "img/code-arrow-brackets.dd53ea8c.svg";